export default __webpack_public_path__ + "static/media/CL01.2.130a53d3.mp3";